<template>
  <v-app id="super-app">
    <search-articles />
    <main-header />
    <div id="content">
      <left-panel />
      <div id="main-content">
        <transition
          name="animate-route"
          mode="out-in"
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
        >
          <router-view class="main-content-anim" />
        </transition>
      </div>
      <right-panel />
    </div>
    <main-footer />
    <transition
      name="animate-route"
      mode="out-in"
      enter-active-class="animated slideInUp"
      leave-active-class="animated slideOutDown"
    >
      <div id="scroll-to-top" class="fixed-action-btn">
        <a class="btn-floating btn-large waves-effect waves-light white">
          <i class="material-icons black-text">keyboard_arrow_up</i></a
        >
      </div>
    </transition>
    <snackbar />
  </v-app>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import SearchArticles from "@/components/SearchArticles";
import MainHeader from "@/components/Header/MainHeader";
import MainFooter from "@/components/MainFooter";
import LeftPanel from "@/components/left-panel/LeftPanel";
import RightPanel from "@/components/right-panel/RightPanel";
import Snackbar from "@/components/Snackbar";
import $ from "jquery";
import { Rest, clearCache } from "@/utils";
import io from "socket.io-client";

@Component({
  components: {
    SearchArticles,
    MainHeader,
    MainFooter,
    LeftPanel,
    RightPanel,
    Snackbar,
  },
})
export default class App extends Vue {

  @Watch('$route.name')
  onRouteChange() {
    document.querySelector('#content').style.setProperty('grid-template-columns', '230px 1fr 230px')
  }

  async created() {
    this.$store.commit("initResizeListener");
    this.$store.commit("initTheme");

    const categories = await Rest.get(`Category`, {
      sort: { name: "ASC" },
    });
    this.$store.commit("setCategories", categories);

    $(document).on("click", "button", function() {
      $(this).blur();
    });
    $(document).on("click", ".modal-overlay", function() {
      document.querySelector('#header-content').style.zIndex = 5
    });
  }

  @Watch("$store.state.user.loggedInUser")
  async watchLoggedInUser() {
    this.$store.dispatch("loadInitialEntities");
  }

  get isMobile() {
    return this.$store.state.isMobile;
  }

  listenToCacheReload() {
    const socket = io();
    socket.on("clearCache", async (data) => {
      const articleChanged = data.split(" ").includes("/rest/Article");
      const isViewingCalendar = this.$route.name == "calendar";
      // console.log('clearCache:', data, 'Should clear:', articleChanged && !isViewingCalendar)
      if (articleChanged && !isViewingCalendar) {
        await clearCache();
        this.$store.commit("toggleSnackbarRefresh", {
          text: this.$store.state.user.langEng
            ? "New site updates were made."
            : "Sidan har uppdaterats.",
        });
      }
    });
  }

  mounted() {
    let backToTop = $("#scroll-to-top");

    const gotoTopToggle = () => {
      if ($(window).scrollTop() > 250) {
        backToTop.fadeIn();
      } else {
        backToTop.fadeOut();
      }
    }

    $(window).scroll(gotoTopToggle);
    gotoTopToggle()

    backToTop.click(() => {
      window.scrollTo(0, 0);
    });
    
    // this.listenToCacheReload();
    
    if (this.$route.name == "home") {
      document.title = "Node Hill " + location.hostname.split(".")[0];
    }
  }
}
</script>
<style scoped lang="scss">
#scroll-to-top {
  display: none;
  z-index: 1000;
}

#content {
  display: grid;
  column-gap: 5px;
  grid-template-columns: 230px 1fr 230px;
  position: relative;
  .left-drawer {
    grid-column: 1/2;
    width: 230px;
  }
  #main-content {
    grid-column: 2/3;
    width: 100%;
  }
  .right-drawer {
    grid-column: 3/4;
    width: 230px;
  }
}

@media (max-width: 992px) {
  #content {
    display: block;
    left-drawer, .right-drawer {
      width: 0 !important;
    }
  }
}
</style>
